/* eslint-disable object-curly-newline */
import restAPI from "../http-common";
import session from "./session";
import store from "@/store";

class SettinsApi {
	setGuestCountDefaults({ defaults, target, stsID, date }) {
		return restAPI({
			method: "put",
			url: "/set-guest-count-defaults",
			data: {
				outlet_id: store.getters["user/activeOutlet"].outlet_id,
				sts_id: stsID,
				target,
				date,
				defaults
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	getGuestCount(startDate, endDate) {
		return restAPI({
			method: "get",
			url: "/get-guest-count",
			params: {
				"start_date": startDate.format("DD/MM/YYYY"),
				"end_date": endDate.format("DD/MM/YYYY"),
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setGuestCount(guestCount) {
		return restAPI({
			method: "put",
			url: "/set-guest-count",
			data: {
				outlet_id: store.getters["user/activeOutlet"].outlet_id,
				guest_counts: guestCount,
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	/**
	 * Gets the outlet menu items.
	 *
	 * @param      {Object}  arg1 Request body
	 * @param      {number}  arg1.categoryId
	 * @param      {string}  arg1.query
	 * @param      {'asc'|'desc'}  arg1.sort
	 * @param      {number}  arg1.limit
	 * @param      {number}  arg1.offset
	 * @param      {string}  arg1.sortBy
	 */
	getOutletLabels({
		categoryId, query, sort, limit, offset, sortBy
	}) {
		return restAPI({
			method: "get",
			url: "/outlet-labels",
			params: {
				group_id: categoryId,
				search_query: query,
				sort_direction: sort,
				sort_by: sortBy,
				limit,
				offset,
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	/**
	 * Gets the outlet menu items.
	 *
	 * @param      {Object}  arg1 Request body
	 * @param      {number}  arg1.categoryId
	 * @param      {string}  arg1.query
	 * @param      {'asc'|'desc'}  arg1.sort
	 * @param      {number}  arg1.limit
	 * @param      {number}  arg1.offset
	 */
	getGlobalLabels({
		categoryId, query, sort, limit, offset
	}) {
		return restAPI({
			method: "get",
			url: "/global-labels",
			params: {
				group_id: categoryId,
				search_query: query,
				sort_direction: sort,
				limit,
				offset,
				exclude_outlet: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	/**
	 * @param      {number[]}  labelIds  The label identifiers
	 */
	setLabelsToOutlet(labelIds) {
		return restAPI({
			method: "put",
			url: "/label-to-outlet",
			data: {
				label_ids: labelIds,
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setLabelPrice(requestBody) {
		return restAPI({
			method: "put",
			url: "/outlet-label-price",
			data: {
				...requestBody,
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setOutletTrackedLabels(labels) {
		return restAPI({
			method: "put",
			url: "/tracked-labels",
			data: {
				labels: labels,
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setTrackedLabelDates({
		label, startDate, endDate
	}) {
		return restAPI({
			method: "PATCH",
			url: "/set-tracked-label-dates",
			data: {
				label_id: label,
				start_date: startDate,
				end_date: endDate,
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}
}

export const SettingsService = new SettinsApi();
